import App from './App';
import './ws';
import { createRoot } from 'react-dom/client';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('No container found');
}
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// ReactDOM.render(
//   <React.StrictMode>
//     <HTTPSredirect>
//       <App />
//     </HTTPSredirect>
//   </React.StrictMode>,
//   document.getElementById('root')
// );
